// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c41f1bb5","126":"01e1b4e4","171":"e9053763","378":"51ff9957","453":"86d3c87c"}[chunkId] + ".chunk.js";
};